export default __webpack_public_path__ + "static/media/chevron-left.ee5197f9.svg";